<label [attr.for]="inputId" (blur)="blur()" class="switch">
  <input
    [attr.test-id]="inputState"
    type="checkbox"
    [attr.aria-labelledby]="inputId + '-label'"
    [attr.id]="inputId"
    [disabled]="disabled"
    [checked]="checked"
    (click)="click()"
  />
  <span [msTooltip]="tooltip()" class="slider round"></span>
</label>
<label [id]="inputId + '-label'" [attr.for]="inputId" (blur)="blur()"><ng-content></ng-content></label>
